export default __webpack_public_path__ + "static/media/Import Care Professional Template.b46b089a.xlsx";